import { render, staticRenderFns } from "./ExaminationPdfFilePopup.vue?vue&type=template&id=c4dca2a6&scoped=true&"
import script from "./ExaminationPdfFilePopup.vue?vue&type=script&lang=js&"
export * from "./ExaminationPdfFilePopup.vue?vue&type=script&lang=js&"
import style0 from "./ExaminationPdfFilePopup.vue?vue&type=style&index=0&id=c4dca2a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4dca2a6",
  null
  
)

export default component.exports